// extracted by mini-css-extract-plugin
export default {"faqModal":"PickupModal_faqModal__eXRs8","closeBtn":"PickupModal_closeBtn__AJB0z","faqItem":"PickupModal_faqItem__sOqy3","scaleIn":"PickupModal_scaleIn__rGfCS"};